import {
  scCoreModule
} from '../core/core.module';

import {
  FaceService
} from './face.service';

export const scFaceModule = 'sc-face';

angular.module(scFaceModule, [])
  .service('FaceService', FaceService);



// WEBPACK FOOTER //
// ./src/face/face.module.js